import matter from 'gray-matter';
import { BlogPost, BlogPostMetadata, Language } from '../types';
import { sortPostsByDate } from './date';
import { Buffer } from 'buffer';
import { BLOG_FILES } from './blogFiles';

globalThis.Buffer = Buffer;
// Buffer polyfill added for gray-matter compatibility

export async function loadBlogPosts(language: Language = 'en'): Promise<BlogPost[]> {
  const posts: BlogPost[] = [];

  try {
    // Use the generated list of blog files

    for (const filename of BLOG_FILES) {
      try {
        const response = await fetch(`../content/blog/${filename}`);
        const rawContent = await response.text();
        const str = rawContent;
        const { data, content } = matter(str);
        const metadata = data as BlogPostMetadata;

        // Filter by language and published status
        if (metadata.published && metadata.language === language) {
          const id = filename.replace('.md', '');

          const post: BlogPost = {
            id,
            title: metadata.title,
            date: metadata.date,
            excerpt: metadata.excerpt,
            content: content,
            tags: metadata.tags,
            readTime: metadata.readTime,
            vgWortPixel: metadata.vgWortPixel,
            published: metadata.published,
            language: metadata.language
          };

          posts.push(post);
        }
      } catch (error) {
        console.error(`Error loading blog post ${filename}:`, error);
      }
    }
  } catch (error) {
    console.error('Error loading blog posts:', error);
  }

  return sortPostsByDate(posts);
}

export async function loadBlogPost(id: string, language: Language = 'en'): Promise<BlogPost | null> {
  try {
    const filename = `${id}.md`;
    const response = await fetch(`../content/blog/${filename}`);
    const rawContent = await response.text();
    const { data, content } = matter(rawContent);
    const metadata = data as BlogPostMetadata;

    // Check if post is published and matches language
    if (!metadata.published || metadata.language !== language) {
      return null;
    }

    return {
      id,
      title: metadata.title,
      date: metadata.date,
      excerpt: metadata.excerpt,
      content: content,
      tags: metadata.tags,
      readTime: metadata.readTime,
      vgWortPixel: metadata.vgWortPixel,
      published: metadata.published,
      language: metadata.language
    };
  } catch (error) {
    console.error(`Error loading blog post ${id}:`, error);
    return null;
  }
}